// Top-level React Router route table and account-type redirects.
// Mistake: This file previously had no purpose header; add one to reduce accidental route regressions during edits.
import React, { useEffect } from "react";
import { MainLayout } from "./commons";
import { Routes, Route, useLocation } from "react-router-dom";
import {

    // common
    CommonHome,
    CommonLogin,
    CommonLoginOauthWannabe,
    CommonLogout,
    CommonMission,
    CommonPricing,
    CommonSignup,
    CommonPasswordReset,
    CommonPasswordResetDone,
    CommonVerifyPasswordEmail,
    CommonVerifyPasswordEmailDone,
    CommonTerm,
    CommonUpdateEmail,
    CommonVerifyEmail,
    CommonVerifyCastingEmail,
    CommonVerifyParentEmail,
    CommonStudentDetail,
    CommonSubscribeEmail,
    CommonSubscribeEmailDone,
    CommonUnSubscribeEmail,
    CommonUnSubscribeEmailDone,
    CommonNotice,
    CommonNoticeDetail,
    CommonNotificationLink,
    CommonLandingInfoContainer,
    CommonLineLiffCallback,

    /* V2 School */
    V2SchoolLayout,
    // Home
    V2SchoolHome,
    // Student
    V2SchoolStudentHome,
    V2SchoolStudentList,
    // Casting
    V2SchoolCastingHome,
    V2SchoolCastingMessage,

    /* V2 Student */
    V2StudentLayout,
    V2StudentHome,
    V2StudentHomeSubjectTimeline,

    V2StudentProfileHome,
    V2StudentProfilePublicProfile,
    V2StudentProfilePublicProfileEssentialInfoEdit,
    V2StudentProfilePublicProfileAdditionalInfoEdit,
    V2StudentProfilePublicProfileBodyInfoEdit,
    V2StudentProfileAgencyProfile,
    V2StudentProfileAgencyProfilePhoto,
    V2StudentProfileAgencyProfileVideo,
    V2StudentProfilePortfolio,
    V2StudentProfilePortfolioDetail,
    V2StudentProfilePortfolioCreate,


    // Statistics
    V2StudentStatisticsHome,

    // Fan page
    V2StudentFanPageHome,
    V2StudentFanPagePhotos,
    V2StudentFanPageQnA,
    V2StudentFanPagePost,
    V2StudentFanPagePostForm,
    V2StudentFanPagePostInfo,

    // Casting
    V2StudentCastingHome,
    V2StudentCastingMessageHome,
    V2StudentCastingMessageChat,
    // export { V2CastingMessageDetailContainer as V2StudentCastingMessageDetail } from "./student/v2";

    // Student Hub
    V2StudentHubHome,
    V2StudentHubNoticeIndexContainer,
    V2StudentHubNoticeDetailContainer,
    V2StudentHubRank,
    V2StudentHubCastingIndexContainer,
    V2StudentHubAgencyIndexContainer,
    V2StudentHubEventIndexContainer,
    V2StudentHubEventDetailContainer,
    V2StudentMagazineIndex,
    V2StudentMagazineDetail,

    // Growth
    V2StudentGrowthHome,
    V2StudentGrowthDiary,
    V2StudentGrowthDiaryDetail,
    V2StudentGrowthDiaryWrite,
    V2StudentGrowthChallenge,
    V2StudentGrowthChallengeDetail,
    V2StudentGrowthPortfolio,
    V2StudentGrowthClass,
    V2StudentGrowthContents,
    V2StudentGrowthMission,

    // Notification
    V2StudentAlarmHome,

    // Follow
    V2FollowHome,

    // My Page
    V2StudentMyHome,
    V2StudentMyChangePassword,
    V2StudentMyChangeParentEmail,
    V2StudentMyUpdateMyContact,
    V2StudentMyDeleteAccount,
    V2StudentMyStadia,

    // Block
    V2StudentBlock,
    V2StudentCheckout,
    // StudentProfileIntro,
    // StudentProfileImage,
    // StudentPracticeDetail,
    // StudentPracticeNew,
    // StudentFanPageHome,
    // StudentFanPagePhotos,
    // StudentFanPagePost,
    // StudentFanPageQnA,
    // StudentFanPagePostForm,
    // StudentFanPagePostInfo,


    // StudentHubHome,
    // StudentHubCommunity,
    // StudentHubFollow,

    StudentAudition,
    StudentAuditionDetail,
    StudentAuditionApply,

    StudentMessageDetail,
    StudentMessageAgencyDetail,
    StudentMy,
    StudentNotification,
    StudentHomeV2,
    StudentLayout,

    // agency
    V2AgencyLayout,
    V2AgencyHome,
    V2AgencySearch,
    V2AgencyFavorite,
    V2AgencyMessage,
    V2AgencyMessageChat,
    BookmarkDiary,
    V2AgencyMy,
    V2AgencyMyPassword,
    V2AgencyMyCellphone,
    V2AgencyMyDeleteAccount,
    V2AgencyMyTerms,
    V2AgencyStudent,
    V2AgencyAlarm,
    V2AgencyHubNotice,
    V2AgencyHubNoticeDetail,
    V2AgencyHubRank,

    AgencyHome,
    AgencySignupDone,
    AgencyWannabeInfo,
    AgencyWannabePracticeVideo,
    AgencyWannabePracticeVideoInfo,
    AgencyWannabeProfile,
    AgencyWannabeSchoolEvaluation,
    AgencyFavorite,
    AgencyAudition,
    AgencyAuditionNew,
    AgencyAuditionDetail,
    AgencyAuditionApplicant,
    AgencyMessage,
    AgencyMessageDetail,
    AgencySearch,
    AgencyMy,
    AgencyNotification,


    // school
    SchoolHome,
    SchoolSignupDone,
    SchoolStudent,
    SchoolStudentDetail,
    SchoolStudentRegister,
    SchoolPortfolio,
    SchoolPortfolioDetail,
    SchoolCreatePortfolio,
    SchoolUpdatePortfolio,
    SchoolAudition,
    SchoolMessage,
    SchoolMessageDetail,
    SchoolMy,
    SchoolNotification,
    V2StudentMyCellphone,
    V2StudentInfoHome,
    V2StudentMyTerms,

    // Koach
    V2KoachHome,
    V2KoachLayout,

    V2KoachCoaching,
    V2KoachCoachingDiary,
    V2KoachCoachingClass,

    V2KoachCoachingContents,
    V2KoachContentsContentsInfo,
    V2KoachContentsContentsEdit,

    V2KoachSales,
    V2KoachSalesProduct,
    V2KoachSalesStatus,
    V2KoachSalesSettlement,

    V2KoachProfile,
    V2KoachProfileBasic,
    V2KoachProfileReview,
    V2KoachMy,
    V2KoachMyNoticeIndex,
    V2KoachMyNoticeDetail,
    V2KoachMyChangePassword,
    V2KoachMyCellphone,
    V2KoachAlarm,
    V2AgencyCastingHome,

} from "./pages";

import { PAGE_TYPE } from "enums";
import { Error500Container, Error400Container } from "pages/common/error";
import LayoutCompactContainer from "commons/layout/LayoutCompact.container";
import LayoutOnlyHomeButton from "commons/layout/LayoutOnlyHomeButton.component";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sendPageViewCompleted } from "helpers/Gtm.helper";
import { getCookieSetting } from "helpers/Cookie.helper";
import CookieSettingPopupContainer from "commons/popup/CookieSettingPopup.container";
import { usePopup } from "contexts/PopupContext";
import { setNotiFilterByPath } from "helpers/InApp.helper";
import { getIsIos } from "helpers/InApp.helper";
import StudentSignupContainer from "pages/common/signup/StudentSignup.container";

const Router = (props: any) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { showPopup } = usePopup();
    const { info: myInfo } = useSelector((state: any) => state.user);
    const { isApp } = useSelector((state: any) => state.common);

    useEffect(() => {
        // if (
        //     myInfo?.accountTypeCode === "accountType:student" &&
        //     myInfo?.hasDoneSignup === false &&
        //     !location.pathname.startsWith("/signup/student/register")
        // ) {
        //     navigate("/signup/student/register/profile", { replace: true });
        //     return;
        // }

        // 주소가 로그아웃이 아닐경우
        // 계정 타입에 따라 페이지 이동
        if (!location.pathname.startsWith('/logout')
            && !location.pathname.startsWith('/notification-link')
            && !location.pathname.startsWith('/verification/email')
        ) {
            // 계정 타입이 있는 경우
            if (myInfo?.accountTypeCode) {
                // 학생 계정인 경우
                if (myInfo?.accountTypeCode === 'accountType:student') {
                    const isStudentSignupRequired = myInfo?.hasDoneSignup === false;
                    if (isStudentSignupRequired && !location.pathname.startsWith("/student/signup")) {
                        navigate("/student/signup", { replace: true });
                        return;
                    }
                    if (!isStudentSignupRequired && location.pathname.startsWith("/student/signup")) {
                        navigate("/student", { replace: true });
                        return;
                    }
                    if (!location.pathname.startsWith("/student")) {
                        navigate("/student");
                    }
                } else if (myInfo?.accountTypeCode === 'accountType:agency') {
                    // 기획사 계정인 경우
                    if (!location.pathname.startsWith("/agency")) {
                        navigate("/agency");
                    }
                } else if (myInfo?.accountTypeCode === 'accountType:school') {
                    // 학교 계정인 경우
                    if (!location.pathname.startsWith("/school")) {
                        navigate("/school");
                    }
                }
            } else {
                // 계정 타입이 없는 경우
                if (location.pathname.startsWith("/student") ||
                    location.pathname.startsWith("/agency") ||
                    location.pathname.startsWith("/school")) {
                    // 학생, 기획사, 학교 페이지로 이동한 경우 홈으로 이동
                    navigate("/", { replace: true });
                } 
            }
        }

        if (!getCookieSetting()) {
            showPopup(<CookieSettingPopupContainer />);
        }

        sendPageViewCompleted(location.pathname, window.document.location.href);

        if (isApp) {
            setNotiFilterByPath(location.pathname);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (!isApp) {
            return;
        }
        const normalizedPath = (location.pathname || "/").replace(/\/+$/, "") || "/";
        const isBlockedHomePath = normalizedPath === "/student" || normalizedPath === "/koach" || normalizedPath === "/agency";
        if (!isBlockedHomePath) {
            return;
        }

        let mounted = true;
        let isAndroidApp = false;
        const blockAndroidBack = () => {
            if (!isAndroidApp) {
                return;
            }
            window.history.pushState(null, "", window.location.href);
        };

        (async () => {
            try {
                const isIos = await getIsIos();
                if (!mounted) {
                    return;
                }
                isAndroidApp = !isIos;
                if (!isAndroidApp) {
                    return;
                }
                window.history.pushState(null, "", window.location.href);
                window.addEventListener("popstate", blockAndroidBack);
            } catch {
                // ignore
            }
        })();

        return () => {
            mounted = false;
            window.removeEventListener("popstate", blockAndroidBack);
        };
    }, [location.pathname, isApp]);


    return (
        <Routes>
            {/* common*/}
            {/* <Route element={<MainLayout isPrivate={false} pageType={PAGE_TYPE.COMMON} />}>
                <Route path="/" element={<CommonHome />} />
                <Route path="/about" element={<CommonAbout />} />
                <Route path="/mission" element={<CommonMission />} />
                <Route path="/partner" element={<CommonPartner />} />
                <Route path="/pricing" element={<CommonPricing />} />
                <Route path="/contact" element={<CommonContact />} />
                <Route path="/search/:keyword" element={<CommonSearch />} />
                <Route path="/audition" element={<CommonAudition />} />
                <Route path="/info/:id" element={<CommonLandingInfoContainer />} />
                <Route path="/audition/:id/:type" element={<CommonAuditionDetail />} />
                <Route path="/wannabe/info/:slug" element={<CommonStudentDetail />} />
            </Route> */}

            <Route path="/notification-link" element={<CommonNotificationLink />} />

            <Route element={<MainLayout isPrivate={false} pageType={PAGE_TYPE.COMMON} />}>
                <Route path="/" element={<CommonHome />} />
                <Route path="/mission" element={<CommonMission />} />
                <Route path="/price" element={<CommonPricing />} />
                <Route path="/info/:id" element={<CommonLandingInfoContainer />} />
                <Route path="/wannabe/info/:slug" element={<CommonStudentDetail />} />
            </Route>

            {/* school*/}
            <Route path="/school" element={<V2SchoolLayout />}>
                <Route index element={<V2SchoolHome />} />
                <Route path="student" element={<V2SchoolStudentHome />} />
                <Route path="student/list" element={<V2SchoolStudentList />} />
                <Route path="casting" element={<V2SchoolCastingHome />} />
                <Route path="casting/message" element={<V2SchoolCastingMessage />} />
                {/* 
                <Route path="student/:id" element={<SchoolStudentDetail />} />
                <Route path="student/new" element={<SchoolStudentRegister />} />
                <Route path="student/:id/edit" element={<SchoolStudentRegister />} />
                <Route path="portfolio" element={<SchoolPortfolio />} />
                <Route path="portfolio/:id" element={<SchoolPortfolioDetail />} />
                <Route path="portfolio/new" element={<SchoolCreatePortfolio />} />
                <Route path="portfolio/edit/:id" element={<SchoolUpdatePortfolio />} />
                <Route path="message" element={<SchoolMessage />} />
                <Route path="message/:id" element={<SchoolMessageDetail />} />
                <Route path="audition" element={<SchoolAudition />} />
                <Route path="my" element={<SchoolMy />} />
                <Route path="my/update-password" element={<CommonUpdatePassword />} />
                <Route path="my/update-email" element={<CommonUpdateEmail />} />
                <Route path="my/update-school" element={<SchoolMy />} />
                <Route path="my/update-contact" element={<SchoolMy />} />
                <Route path="my/update-sns" element={<SchoolMy />} />
                <Route path="my/delete-account" element={<CommonDeleteAccount />} />
                <Route path="notification" element={<SchoolNotification />} />
                <Route path="notice" element={<CommonNotice />} />
                <Route path="notice/:id" element={<CommonNoticeDetail />} /> 
                */}
            </Route>

            {/* agency*/}
            <Route path="/agency" element={<V2AgencyLayout />}>
                <Route index element={<V2AgencyHome />} />
                {/* 검색 */}
                <Route path="search" element={<V2AgencySearch />} />
                {/* 즐겨찾기 */}
                <Route path="favorite/aspirant" element={<V2AgencyFavorite />} />
                <Route path="favorite/diary" element={<BookmarkDiary />} />
                {/* 메시지 */}
                <Route path="casting" element={<V2AgencyCastingHome />} />
                <Route path="casting/message" element={<V2AgencyMessage />} />
                <Route path="casting/message/:channelId" element={<V2AgencyMessageChat />} />
                {/* 지망생 */}
                <Route path="student/:userStudentId" element={<V2AgencyStudent />} />
                {/* My Page */}
                <Route path="my" element={<V2AgencyMy />} />
                <Route path="my/password" element={<V2AgencyMyPassword />} />
                <Route path="my/cellphone" element={<V2AgencyMyCellphone />} />
                <Route path="my/withdraw" element={<V2AgencyMyDeleteAccount />} />
                <Route path="my/terms/:termsId" element={<V2AgencyMyTerms />} />
                <Route path="alarm" element={<V2AgencyAlarm />} />
                {/* Hub */}
                <Route path="hub/notice" element={<V2AgencyHubNotice />} />
                <Route path="hub/notice/:noticeId" element={<V2AgencyHubNoticeDetail />} />
                <Route path="hub/rank" element={<V2AgencyHubRank />} />
            </Route>
            {/* 
            <Route path="/agency-bak" element={<MainLayout isPrivate={true} pageType={PAGE_TYPE.AGENCY} />}>
                <Route index element={<AgencyHome />} />
                <Route index element={<V2AgencyHome />} />
                <Route path="wannabe/info/:id" element={<AgencyWannabeInfo />} />
                <Route path="wannabe/practice-video/:id" element={<AgencyWannabePracticeVideo />} />
                <Route path="wannabe/practice-video-info/:id" element={<AgencyWannabePracticeVideoInfo />} />
                <Route path="wannabe/profile/:id" element={<AgencyWannabeProfile />} />
                <Route path="wannabe/:id" element={<AgencyWannabeInfo />} />
                <Route path="wannabe/school-evaluation/:id" element={<AgencyWannabeSchoolEvaluation />} />
                <Route path="favorite" element={<AgencyFavorite />} />
                <Route path="audition" element={<AgencyAudition />} />
                <Route path="audition/:id" element={<AgencyAuditionDetail />} />
                <Route path="audition/new" element={<AgencyAuditionNew />} />
                <Route path="audition/applicant/:id" element={<AgencyAuditionApplicant />} />
                <Route path="message" element={<AgencyMessage />} />
                <Route path="message/:id" element={<AgencyMessageDetail />} />
                <Route path="my" element={<AgencyMy />} />
                <Route path="my/update-password" element={<CommonUpdatePassword />} />
                <Route path="my/update-email" element={<CommonUpdateEmail />} />
                <Route path="my/update-agency" element={<AgencyMy />} />
                <Route path="my/update-caster" element={<AgencyMy />} />
                <Route path="my/update-sns" element={<AgencyMy />} />
                <Route path="my/update-artist" element={<AgencyMy />} />
                <Route path="my/delete-account" element={<CommonDeleteAccount />} />
                <Route path="search" element={<AgencySearch />} />
                <Route path="notification" element={<AgencyNotification />} />
                <Route path="notice" element={<CommonNotice />} />
                <Route path="notice/:id" element={<CommonNoticeDetail />} />
            </Route> */}

            {/* koach*/}
            <Route path="/koach" element={<V2KoachLayout />}>
                <Route index element={<V2KoachHome />} />

                {/* 코칭 */}
                <Route path="coaching" element={<V2KoachCoaching />} />
                <Route path="coaching/diary" element={<V2KoachCoachingDiary />} />
                <Route path="coaching/class" element={<V2KoachCoachingClass />} />
                <Route path="coaching/contents" element={<V2KoachCoachingContents />} />

                {/* 컨텐츠 */}
                <Route path="coaching/contents" element={<V2KoachCoachingContents />} />
                <Route path="coaching/contents/create" element={<V2KoachContentsContentsEdit />} />
                <Route path="coaching/contents/:id" element={<V2KoachContentsContentsInfo />} />
                <Route path="coaching/contents/:id/edit" element={<V2KoachContentsContentsEdit />} />

                {/* 판매 */}
                <Route path="sales" element={<V2KoachSales />} />
                <Route path="sales/product" element={<V2KoachSalesProduct />} />
                <Route path="sales/status" element={<V2KoachSalesStatus />} />
                <Route path="sales/settlement" element={<V2KoachSalesSettlement />} />

                {/* 프로필 */}
                <Route path="profile" element={<V2KoachProfile />} />
                <Route path="profile/basic" element={<V2KoachProfileBasic />} />
                <Route path="profile/review" element={<V2KoachProfileReview />} />

                {/* 마이페이지 */}
                <Route path="my" element={<V2KoachMy />} />
                <Route path="my/password" element={<V2KoachMyChangePassword />} />
                <Route path="my/cellphone" element={<V2KoachMyCellphone />} />
                <Route path="my/notice" element={<V2KoachMyNoticeIndex />} />
                <Route path="my/notice/:noticeId" element={<V2KoachMyNoticeDetail />} />

                {/* 알림 */}
                <Route path="alarm" element={<V2KoachAlarm />} />
            </Route>

            {/* student*/}
            <Route path="/student" element={<V2StudentLayout isPrivate={true} pageType={PAGE_TYPE.STUDENT} />}>
                <Route
                    path="signup/*"
                    element={
                        <StudentSignupContainer
                            cancelSignup={() => {
                                navigate("/student", { replace: true });
                            }}
                            accountTypeCode="accountType:student"
                            registerBasePath="/student/signup"
                            accountPath="/student/signup/account"
                            profilePath="/student/signup"
                            signupMethodPath="/student"
                            forceInfoRegistrationFlow={true}
                        />
                    }
                />
                <Route index element={<V2StudentHome />} />
                <Route path="subject/:subject" element={<V2StudentHomeSubjectTimeline />} />

                <Route path="profile" element={<V2StudentProfileHome />} />

                <Route path="profile/public" element={<V2StudentProfilePublicProfile />} />
                <Route path="profile/public/essential-info/edit" element={<V2StudentProfilePublicProfileEssentialInfoEdit />} />
                <Route path="profile/public/body-info/:type/edit" element={<V2StudentProfilePublicProfileBodyInfoEdit />} />
                <Route path="profile/public/additional-info/edit" element={<V2StudentProfilePublicProfileAdditionalInfoEdit />} />

                <Route path="profile/agency" element={<V2StudentProfileAgencyProfile />} />
                <Route path="profile/agency/photo/:category/:type" element={<V2StudentProfileAgencyProfilePhoto />} />
                <Route path="profile/agency/intro-video" element={<V2StudentProfileAgencyProfileVideo />} />

                <Route path="profile/portfolio" element={<V2StudentProfilePortfolio />} />
                <Route path="profile/portfolio/create" element={<V2StudentProfilePortfolioCreate />} />
                <Route path="profile/portfolio/:id" element={<V2StudentProfilePortfolioDetail />} />

                {/* <Route path="statistics" element={<V2StudentStatisticsHome />} /> */}

                <Route path="fan-page" element={<V2StudentFanPageHome />} />
                <Route path="fan-page/photos" element={<V2StudentFanPagePhotos />} />
                <Route path="fan-page/post" element={<V2StudentFanPagePost />} />
                <Route path="fan-page/post/:id" element={<V2StudentFanPagePostInfo />} />
                <Route path="fan-page/post/:id/edit" element={<V2StudentFanPagePostForm />} />
                <Route path="fan-page/qna" element={<V2StudentFanPageQnA />} />

                <Route path="casting" element={<V2StudentCastingHome />} />
                <Route path="casting/message" element={<V2StudentCastingMessageHome />} />
                <Route path="casting/message/:channelId/chat" element={<V2StudentCastingMessageChat />} />

                <Route path="growth" element={<V2StudentGrowthHome />} />
                <Route path="growth/diary" element={<V2StudentGrowthDiary />} />
                <Route path="growth/diary/:diaryId" element={<V2StudentGrowthDiaryDetail />} />
                <Route path="growth/diary/write" element={<V2StudentGrowthDiaryWrite />} />
                <Route path="growth/challenge" element={<V2StudentGrowthChallenge />} />
                <Route path="growth/challenge/:challengeId" element={<V2StudentGrowthChallengeDetail />} />
                <Route path="growth/portfolio" element={<V2StudentGrowthPortfolio />} />
                <Route path="growth/class" element={<V2StudentGrowthClass />} />
                <Route path="growth/contents" element={<V2StudentGrowthContents />} />
                <Route path="growth/mission" element={<V2StudentGrowthMission />} />

                <Route path="alarm" element={<V2StudentAlarmHome />} />

                {/* 특정 메뉴에 속하지 않은 페이지 */}
                <Route path="follow" element={<V2FollowHome />} />
                <Route path="wannabe/:studentId" element={<V2StudentInfoHome />} />


                {/* My */}
                <Route path="my" element={<V2StudentMyHome />} />
                <Route path="my/password" element={<V2StudentMyChangePassword />} />
                <Route path="my/parent-email" element={<V2StudentMyChangeParentEmail />} />
                <Route path="my/cellphone" element={<V2StudentMyCellphone />} />
                <Route path="my/contact" element={<V2StudentMyUpdateMyContact />} />
                <Route path="my/delete-account" element={<V2StudentMyDeleteAccount />} />
                <Route path="my/terms/:termsId" element={<V2StudentMyTerms />} />
                <Route path="my/notice" element={<V2StudentHubNoticeIndexContainer />} />
                <Route path="my/notice/:noticeId" element={<V2StudentHubNoticeDetailContainer />} />
                <Route path="my/stadia" element={<V2StudentMyStadia />} />
                <Route path="checkout" element={<V2StudentCheckout />} />

                {/* Block */}
                <Route path="block" element={<V2StudentBlock />} />
                <Route path="my/update-email" element={<CommonUpdateEmail />} />
                <Route path="my/update-profile" element={<StudentMy />} />
                <Route path="my/update-contact" element={<StudentMy />} />
                <Route path="notification" element={<StudentNotification />} />
                <Route path="notice" element={<CommonNotice />} />
                <Route path="notice/:id" element={<CommonNoticeDetail />} />

                {/* <Route path="profile/agency/intro" element={<StudentProfileIntro />} />
                    <Route path="profile/agency/:category/:type" element={<StudentProfileImage />} /> */}
                {/* <Route
                    path="profile/practice/:id"
                    element={<StudentPracticeDetail />}
                />

                <Route path="profile/practice/new" element={<StudentPracticeNew />} />
                <Route
                    path="profile/practice/:id/edit"
                    element={<StudentPracticeNew />}
                /> */}

                {/* <Route path="casting/message/:id" element={<StudentCastingMessageDetail />} /> */}

                <Route path="hub" element={<V2StudentHubHome />} />
                <Route path="hub/rank" element={<V2StudentHubRank />} />
                <Route path="hub/casting-log" element={<V2StudentHubCastingIndexContainer />} />
                <Route path="hub/agency" element={<V2StudentHubAgencyIndexContainer />} />
                <Route path="hub/event" element={<V2StudentHubEventIndexContainer />} />
                <Route path="hub/event/:eventId" element={<V2StudentHubEventDetailContainer />} />
                <Route path="hub/magazine" element={<V2StudentMagazineIndex />} />
                <Route path="hub/magazine/:id" element={<V2StudentMagazineDetail />} />
                {/* <Route path="hub/community" element={<V2StudentHubCommunity />} />
                <Route path="hub/follow" element={<V2StudentHubFollow />} /> */}


                {/* <Route path="my/contact" element={<V2StudentMyContact />} /> */}
                {/* <Route path="my/update-my" element={<V2StudentMyUpdateMy />} />
                    <Route path="my/update-my-contact" element={<V2StudentMyUpdateMyContact />} /> */}

                {/* <Route path="audition" element={<StudentAudition />} />
                    <Route path="audition/:id" element={<StudentAuditionDetail />} />
                    <Route path="audition/apply/:id" element={<StudentAuditionApply />} />
                    <Route path="audition/apply/:id/id/:applicant" element={<StudentAuditionApply />} />
                    <Route path="message" element={<StudentMessageHome />} />
                    <Route path="message/list" element={<StudentMessageList />} />
                    <Route path="message/:id" element={<StudentMessageDetail />} />
                    <Route path="message/agency/:id" element={<StudentMessageAgencyDetail />} /> */}
            </Route>


            {/* 헤더가 불필요한 페이지 */}
            <Route element={<LayoutCompactContainer />}>
                <Route path="/login/oauth-wannabe" element={<CommonLoginOauthWannabe />} />
                <Route path="/login" element={<CommonLogin />} />
                <Route path="/logout" element={<CommonLogout />} />
                <Route path="/line/liff/callback" element={<CommonLineLiffCallback />} />
                <Route path="/signup" element={<CommonSignup />} />
                <Route path="/signup/agency" element={<CommonSignup />} />
                <Route path="/signup/agency/done" element={<AgencySignupDone />} />
                <Route path="/signup/school" element={<CommonSignup />} />
                <Route path="/signup/student/*" element={<CommonSignup />} />
                <Route path="/signup/school/done" element={<SchoolSignupDone />} />
                <Route path="/signup/koach" element={<CommonSignup />} />
                <Route path="/password/reset" element={<CommonPasswordReset />} />
                <Route path="/password/reset/done" element={<CommonPasswordResetDone />} />
            </Route>

            <Route element={<LayoutOnlyHomeButton />}>
                <Route path="/subscribed/new-wannabe" element={<CommonSubscribeEmail />} />
                <Route path="/subscribed/new-wannabe/done" element={<CommonSubscribeEmailDone />} />
                <Route path="/unsubscribed/new-wannabe" element={<CommonUnSubscribeEmail />} />
                <Route path="/unsubscribed/new-wannabe/done" element={<CommonUnSubscribeEmailDone />} />
                <Route path="/verification/email/signup/:token" element={<CommonVerifyEmail />} />
                <Route path="/verification/email/casting/signup/:token" element={<CommonVerifyCastingEmail />} />
                <Route path="/verification/email/parent/:token" element={<CommonVerifyParentEmail />} />
                <Route path="/verification/email/password/reset/:token" element={<CommonVerifyPasswordEmail />} />
                <Route path="/verification/email/password/reset/done" element={<CommonVerifyPasswordEmailDone />} />
            </Route>

            <Route path="/term/common/:id" element={<CommonTerm />} />
            <Route path="/term/etc/:id" element={<CommonTerm />} />
            {/* <Route path="/app/need-update" element={<CommonNeedAppUpdate />} /> */}
            {/* 500 */}
            <Route path="/error/500" element={<Error500Container />} />
            {/* 404 */}
            <Route path="/*" element={<Error400Container />} />
        </Routes>
    );
};

export default Router;
